/* eslint-disable no-unused-vars */
import { useState, Suspense, lazy } from 'react'
import './App.css'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import LoadingSpinner from './components/LoadingSpinner'
import ErrorBoundary from './components/ErrorBoundary'
import WhatsAppChat from './components/WhatsAppChat'

// Lazy load components for better performance
const Home = lazy(() => import('./pages/home'))
const About = lazy(() => import('./pages/about'))
const Contact = lazy(() => import('./pages/contactus'))
const PageNotFound = lazy(() => import('./pages/PageNotFound'))
const Faq = lazy(() => import('./pages/faq'))
const DeliverReturn = lazy(() => import('./pages/del&return'))

function App() {

  return (
    <HelmetProvider>
      <ErrorBoundary>
        <BrowserRouter>
          <Suspense fallback={<LoadingSpinner />}>
            <Routes>
              <Route path='/' element={<Home />}/>
              <Route path='/Home' element={<Home />}/>
              <Route path='/AboutUs' element={<About />}/>
              <Route path='/Faq' element={<Faq />} />
              <Route path='/Deliveries&Returns' element={<DeliverReturn />} />
              <Route path='/ContactUs' element={<Contact />} />

              <Route path="*" element={<PageNotFound />}/>
            </Routes>
          </Suspense>
        </BrowserRouter>
        
        {/* WhatsApp Chat Widget - appears on all pages */}
        <WhatsAppChat />
      </ErrorBoundary>
    </HelmetProvider>
  )
}

export default App
